/*
 * embeeLAB SKÅDIS-Konfigurator – Brücke Shop <-> iframe
 * Der Konfigurator läuft auf Netlify (/skadis/) im iframe. Diese Seite liefert ihm Farben und
 * Preisstufen-Varianten und erledigt alles, was von www.embeelab.de aus passieren muss:
 *   - Warenkorb (/cart/add.js mit Eigenschaften inkl. _konfig für die Produktion)
 *   - Sonderwunsch (get-anfragenr -> Skizze/Fotos nach R2 -> skadis-sonderwunsch)
 * Daten kommen aus window.EMBEELAB_SKADIS (Section el-skadis-konfigurator).
 */
(function () {
  var cfg = window.EMBEELAB_SKADIS;
  var frame = document.getElementById('el-skadis-frame');
  if (!cfg || !frame) return;
  var appOrigin = new URL(frame.src, location.href).origin;

  function antworte(id, daten) {
    frame.contentWindow.postMessage(Object.assign({ typ: 'skadis-antwort', id: id }, daten), appOrigin);
  }

  async function warenkorb(m) {
    var erlaubt = Object.keys(cfg.varianten).some(function (k) { return cfg.varianten[k] === m.variante; });
    if (!erlaubt) throw new Error('Unbekannte Preisstufe');
    // „Ändern“ aus dem Warenkorb: alte Zeile entfernen, bevor die geänderte hinzukommt
    if (m.ersetze && /^[0-9]+:[0-9a-f]+$/.test(m.ersetze)) {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: m.ersetze, quantity: 0 }) });
    }
    var r = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: m.variante, quantity: 1, properties: m.eigenschaften }),
    });
    if (!r.ok) throw new Error('Hinzufügen nicht möglich (HTTP ' + r.status + ')');
    merkeVorschau(m.vorschau);
    antworte(m.id, { ok: true });
    location.href = cfg.warenkorbUrl || '/cart';
  }

  // Vorschaubild der Konfiguration nur im Browser ablegen (localStorage), der Warenkorb zeigt es statt des Produktbilds.
  // Höchstens 30 Bilder / 30 Tage; kein Server, nichts in der Bestellung außer der kurzen Kennung _vorschau.
  function merkeVorschau(v) {
    if (!v || !/^v[a-z0-9]{6,20}$/.test(v.id) || !/^data:image\/jpeg;base64,/.test(v.bild || '')) return;
    try {
      var KEY = 'el-skadis-vorschau', alle = JSON.parse(localStorage.getItem(KEY) || '{}'), jetzt = Date.now();
      alle[v.id] = { t: jetzt, bild: v.bild };
      var ids = Object.keys(alle).filter(function (k) { return jetzt - alle[k].t < 30 * 864e5; })
        .sort(function (a, b) { return alle[b].t - alle[a].t; }).slice(0, 30);
      var neu = {}; ids.forEach(function (k) { neu[k] = alle[k]; });
      localStorage.setItem(KEY, JSON.stringify(neu));
    } catch (e) { /* Speicher voll/gesperrt: dann eben ohne Vorschaubild */ }
  }

  async function json(r) {
    var d = await r.json().catch(function () { return {}; });
    if (!r.ok) throw new Error(d.error || ('HTTP ' + r.status));
    return d;
  }

  async function sonderwunsch(m) {
    var api = cfg.api;
    var nr = await json(await fetch(api + '/get-anfragenr', { method: 'POST' }));
    var namen = [];
    for (var i = 0; i < m.dateien.length && i < 6; i++) {
      var name = m.dateien[i][0].replace(/\.(png|jpg)$/, '_' + nr.anfragenr + '.$1');
      var url = await json(await fetch(api + '/get-upload-url', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId: nr.orderId, filename: name, kind: 'logo' }),
      }));
      var put = await fetch(url.uploadUrl, { method: 'PUT', headers: { 'Content-Type': 'application/octet-stream' }, body: m.dateien[i][1] });
      if (!put.ok) throw new Error('Upload fehlgeschlagen (HTTP ' + put.status + ')');
      namen.push(name);
    }
    await json(await fetch(api + '/skadis-sonderwunsch', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({}, m.daten, {
        orderId: nr.orderId, anfragenr: nr.anfragenr, orderToken: nr.orderToken, dateien: namen,
      })),
    }));
    antworte(m.id, { ok: true, anfragenr: nr.anfragenr });
  }

  window.addEventListener('message', function (e) {
    if (e.origin !== appOrigin || e.source !== frame.contentWindow) return;
    var m = e.data || {};
    if (m.typ === 'skadis-bereit') {
      frame.contentWindow.postMessage({ typ: 'skadis-shop', farben: cfg.farben, varianten: cfg.varianten }, appOrigin);
    } else if (m.typ === 'skadis-warenkorb') {
      warenkorb(m).catch(function (err) { antworte(m.id, { ok: false, fehler: err.message }); });
    } else if (m.typ === 'skadis-sonderwunsch') {
      sonderwunsch(m).catch(function (err) { antworte(m.id, { ok: false, fehler: err.message }); });
    }
  });
})();
